import axios from "axios";
import { decryptData } from "../../Utils/stringUtls";
// import { createBrowserHistory } from "history";

// const history = createBrowserHistory();

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
});

// API request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    // const session = localStorage.getItem("session");
    config.headers.Authorization = "Bearer " + token;
    return config;
  },
  (error) => {
    // Handle request error here
    return Promise.reject(error);
  },
);

// API response interceptor
axiosClient.interceptors.response.use(
  async (response) => {
    // Optional: Verify role consistency with backend
    // If API returns user data with role, compare with localStorage
    const responseData = response.data?.data;
    
    if (responseData?.user?.roleId || responseData?.roleId) {
      const apiEncryptedRole = responseData.user?.roleId || responseData.roleId;
      const apiEncryptedRoleName = responseData.user?.roleName || responseData.roleName || "";
      const storedEncryptedRole = localStorage.getItem("userRole");
      const storedRoleId = storedEncryptedRole ? await decryptData(storedEncryptedRole) : "";
      const apiRoleId = await decryptData(apiEncryptedRole);
      
      if (apiRoleId) {
        localStorage.setItem("userRole", apiEncryptedRole);
      }

      if (apiEncryptedRoleName) {
        localStorage.setItem("role", apiEncryptedRoleName);
      }

      // AES-GCM uses a random IV, so encrypted text changes on every response.
      // Reload only when the decrypted role id changes.
      if (storedRoleId && apiRoleId && apiRoleId !== storedRoleId) {
        console.warn('Role mismatch detected. Backend role differs from localStorage. Refreshing...');

        window.location.reload();
        return;
      }
    }
    
    return response;
  },
  (error) => {
    const errorMessage = error?.response?.data?.message || "";
    if (
      error?.response?.data?.sessionExpired ||
      (typeof errorMessage === 'string' && errorMessage.includes("Unauthenticated")) ||
      (typeof errorMessage === 'string' && errorMessage.includes("Not Logged"))
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("sessionCount");
      localStorage.removeItem("userRole");
      localStorage.removeItem("role");
      localStorage.removeItem("userRoleDecrypted");
      localStorage.removeItem("roleDecrypted");
      window.location.replace("/login");
      return;
    } else {
      const status = error?.response?.status;
      const statusText = error?.response?.statusText;
      // Handle response error here
      return Promise.reject({
        response: error?.response?.data,
        status,
        statusText,
      });
    }
  },
);

export default axiosClient;
